module.exports = __webpack_public_path__ + "img/original-f.e7eb25cc.svg";